import { render, staticRenderFns } from "./deptRule.vue?vue&type=template&id=72905c20&scoped=true&"
import script from "./deptRule.vue?vue&type=script&lang=js&"
export * from "./deptRule.vue?vue&type=script&lang=js&"
import style0 from "./deptRule.vue?vue&type=style&index=0&id=72905c20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72905c20",
  null
  
)

export default component.exports